import React from "react";
import { FaTimes, FaTrash } from "react-icons/fa";
import Button from "../../../../components/Button/Button";
import { statusChip } from "../helpers";

const MessageModal = ({
  isOpen,
  reglement,
  onClose,
  onReminder,
  onEdit,
  onDelete,
}) => {
  if (!isOpen || !reglement) return null;

  return (
    <div className="fixed inset-0 z-[70]">
      {/* overlay */}
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={onClose} aria-hidden />
      {/* modal centrée */}
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="w-full max-w-[640px] bg-white dark:bg-slate-900 rounded-2xl shadow-2xl ring-1 ring-slate-200/70 dark:ring-slate-700/70 flex flex-col max-h-[85vh] overflow-hidden">
          <div className="bg-gradient-to-r from-blue-500 via-violet-500 to-pink-500 px-5 py-4 flex items-center justify-between rounded-t-2xl">
            <h3 className="text-white font-semibold">
              Détails Achat de {reglement?.User?.prenom} {reglement?.User?.nom}
            </h3>
            <button
              onClick={onClose}
              className="inline-flex items-center gap-2 rounded-xl bg-white/10 px-3 py-1.5 text-white hover:bg-white/20"
            >
              <FaTimes />
              <span>Fermer</span>
            </button>
          </div>

          <div className="p-5 overflow-y-auto space-y-4">
            {/* Message utilisateur */}
            <div className="text-sm text-slate-700 dark:text-slate-200 whitespace-pre-wrap leading-relaxed">
              {reglement?.message_achat || "—"}
            </div>

            {/* Détails */}
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div>
                <p className="opacity-60">Date</p>
                <p className="font-medium">
                  {reglement ? new Date(reglement.date_achat).toLocaleDateString() : "—"}
                </p>
              </div>
              <div>
                <p className="opacity-60">Article</p>
                <p className="font-medium">
                  {reglement?.Article?.nom || "Règlement Inscription"}
                </p>
              </div>
              <div>
                <p className="opacity-60">Quantité</p>
                <p className="font-medium">{reglement?.quantite ?? "—"}</p>
              </div>
              <div>
                <p className="opacity-60">Taille</p>
                <p className="font-medium">{reglement?.Article?.taille || "—"}</p>
              </div>
              <div>
                <p className="opacity-60">Type de règlement</p>
                <p className="font-medium">{reglement?.type_reglement || "—"}</p>
              </div>
              <div>
                <p className="opacity-60">Montant</p>
                <p className="font-semibold">
                  {parseFloat(reglement?.prix_total || 0).toFixed(2)} €
                </p>
              </div>
              <div className="col-span-2">
                <p className="opacity-60">Statut</p>
                <span
                  className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold ${statusChip(
                    reglement?.statut_reglement
                  )}`}
                >
                  {reglement?.statut_reglement}
                </span>
              </div>
            </div>

            {/* Actions */}
            <div className="pt-2 flex items-center justify-end gap-2">
              {!["Réglé", "Annulé", "Remboursé"].includes(reglement?.statut_reglement) && (
                <Button text="Rappel" onClick={() => onReminder(reglement)} className="!rounded-xl" />
              )}
              <Button
                text="Modifier"
                onClick={() => onEdit(reglement)}
                className="!rounded-xl"
              />
              <button
                onClick={() => onDelete(reglement?.id)}
                className="inline-flex items-center gap-2 rounded-xl px-3 py-2 bg-rose-600 text-white hover:bg-rose-700"
                title="Supprimer l'achat"
              >
                <FaTrash />
                <span>Supprimer</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageModal;
